@if (keyValid) {
  <div class="sort-key-marker">
    {{ "START_TABLE_COLUMN_SORTING_KEY_" + key + "_END_TABLE_COLUMN_SORTING_KEY" }}
  </div>
}
